/**
 * BibiFashion — comportamentos do layout estilo varejo.
 * Sem dependências (não usa jQuery). Carregado com defer depois do theme.min.js.
 *
 *  - Preço Pix / parcelamento na página de produto (atualiza ao trocar variante)
 *  - Barra fixa "Comprar" no celular
 *  - Seletor de quantidade
 *  - Contador das Ofertas relâmpago
 *  - CEP no cabeçalho e "Calcular frete" (consulta cidade/UF no ViaCEP)
 *  - Setas dos carrosséis horizontais
 */
(function () {
  'use strict';

  var S = window.bibiSettings || {};
  var CEP_KEY = 'bibi:cep';

  /* ------------------------------------------------------------------ *
   * Dinheiro
   * ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || 'R$ {{amount_with_comma_separator}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount_with_comma_separator') {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, '.', ',');
    }
    return match ? format.replace(match[0], value) : value;
  }

  function pixPrice(price) {
    if (!S.pixEnabled || !(S.pixDiscount > 0)) return price;
    return Math.floor(price * (100 - S.pixDiscount) / 100);
  }

  function installments(price) {
    if (!S.installmentsEnabled || !(S.installmentsMax > 1)) return 0;
    var n = S.installmentsMax;
    if (S.installmentMin > 0) n = Math.min(n, Math.floor(price / S.installmentMin));
    return n > 1 ? n : 0;
  }

  function stripTags(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || '';
  }

  /* ------------------------------------------------------------------ *
   * Caixa de preço da página de produto
   * ------------------------------------------------------------------ */
  function updatePriceBox(box, variant) {
    if (!box || !variant) return;

    var price = variant.price;
    var compare = variant.compare_at_price || 0;
    box.setAttribute('data-price', price);

    var compareRow = box.querySelector('[data-bibi-compare-row]');
    if (compareRow) {
      if (compare > price) {
        compareRow.hidden = false;
        var compareEl = box.querySelector('[data-bibi-compare]');
        var offEl = box.querySelector('[data-bibi-off]');
        if (compareEl) compareEl.textContent = stripTags(formatMoney(compare));
        if (offEl) offEl.textContent = Math.round((compare - price) * 100 / compare);
      } else {
        compareRow.hidden = true;
      }
    }

    var main = box.querySelector('[data-bibi-main]');
    if (main) main.textContent = stripTags(formatMoney(pixPrice(price)));

    var n = installments(price);
    var instRow = box.querySelector('[data-bibi-inst-row]');
    if (instRow) {
      instRow.hidden = n < 2;
      if (n > 1) {
        var full = box.querySelector('[data-bibi-full]');
        if (full) full.textContent = stripTags(formatMoney(price));
        box.querySelector('[data-bibi-n]').textContent = n;
        box.querySelector('[data-bibi-inst]').textContent = stripTags(formatMoney(Math.floor(price / n)));
      }
    }

    syncStickyPrice(box.closest('.shopify-section') || document);
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    var scope = (event.target.closest && event.target.closest('.shopify-section')) || event.target;
    var box = scope.querySelector ? scope.querySelector('[data-bibi-price-box]') : null;
    updatePriceBox(box, variant);

    var sticky = scope.querySelector ? scope.querySelector('[data-bibi-sticky-submit]') : null;
    if (sticky) {
      var main = scope.querySelector('.product-form__add-button');
      if (main) {
        sticky.disabled = main.disabled;
        sticky.textContent = main.textContent.trim();
      }
    }
  });

  /* ------------------------------------------------------------------ *
   * Barra fixa "Comprar" (celular)
   * ------------------------------------------------------------------ */
  function syncStickyPrice(scope) {
    var target = scope.querySelector('[data-bibi-sticky-price]');
    var box = scope.querySelector('[data-bibi-price-box]');
    if (!target || !box) return;

    var main = box.querySelector('[data-bibi-main]');
    var label = S.pixEnabled && S.pixDiscount > 0 ? '<span class="bibi-sticky-buy__label">' + escapeHtml(S.pixLabel) + '</span>' : '';
    target.innerHTML = '<strong>' + escapeHtml(main ? main.textContent : '') + '</strong>' + label;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initSticky(root) {
    (root || document).querySelectorAll('[data-bibi-sticky-buy]').forEach(function (bar) {
      if (bar.__bibi) return;
      bar.__bibi = true;

      var scope = bar.closest('.shopify-section') || document;
      var mainButton = scope.querySelector('.product-form__add-button');
      syncStickyPrice(scope);
      if (!mainButton || !('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var below = entry.boundingClientRect.top > 0;
          var visible = !entry.isIntersecting && !below;
          bar.classList.toggle('is-visible', visible);
          bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
          document.body.classList.toggle('bibi-has-sticky-buy', visible);
        });
      });
      observer.observe(mainButton);

      var stickySubmit = bar.querySelector('[data-bibi-sticky-submit]');
      stickySubmit.disabled = mainButton.disabled;
      stickySubmit.addEventListener('click', function () {
        var current = scope.querySelector('.product-form__add-button');
        if (current && !current.disabled) current.click();
        else if (current) current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Quantidade
   * ------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-bibi-qty-minus]');
    var plus = event.target.closest('[data-bibi-qty-plus]');
    if (!minus && !plus) return;

    var input = event.target.closest('[data-bibi-qty]').querySelector('input');
    var value = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, value + (plus ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------ *
   * Contador
   * ------------------------------------------------------------------ */
  function parseEnd(value) {
    var m = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 59);
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-bibi-countdown]').forEach(function (el) {
      if (el.__bibiTimer) clearInterval(el.__bibiTimer);

      var mode = el.getAttribute('data-mode');
      var end = mode === 'date' ? parseEnd(el.getAttribute('data-end')) : null;
      if (mode === 'date' && !end) { el.hidden = true; return; }

      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');

      function tick() {
        var now = new Date();
        var target = end;
        if (mode === 'daily') {
          target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
        }
        var diff = Math.max(0, Math.floor((target - now) / 1000));
        if (diff === 0 && mode === 'date') {
          el.classList.add('is-expired');
          el.querySelector('.bibi-countdown__boxes').textContent = el.getAttribute('data-expired') || '';
          clearInterval(el.__bibiTimer);
          return;
        }
        h.textContent = pad(Math.floor(diff / 3600)) + 'H';
        m.textContent = pad(Math.floor(diff % 3600 / 60)) + 'M';
        s.textContent = pad(diff % 60) + 'S';
      }

      tick();
      el.__bibiTimer = setInterval(tick, 1000);
    });
  }

  /* ------------------------------------------------------------------ *
   * CEP
   * ------------------------------------------------------------------ */
  function readCep() {
    try { return JSON.parse(localStorage.getItem(CEP_KEY) || 'null'); } catch (e) { return null; }
  }

  function saveCep(data) {
    try { localStorage.setItem(CEP_KEY, JSON.stringify(data)); } catch (e) { /* navegação privada */ }
  }

  function maskCep(value) {
    var digits = String(value || '').replace(/\D/g, '').slice(0, 8);
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  function renderCep(data) {
    document.querySelectorAll('[data-bibi-cep-label]').forEach(function (label) {
      if (!data) { label.textContent = label.getAttribute('data-default'); return; }
      label.textContent = data.city ? 'Enviar para ' + data.city + ' - ' + data.uf : 'CEP ' + data.cep;
    });

    document.querySelectorAll('[data-bibi-cep-box]').forEach(function (box) {
      var input = box.querySelector('[data-bibi-cep-input]');
      var result = box.querySelector('[data-bibi-cep-result]');
      if (!data) { result.hidden = true; return; }

      if (input && document.activeElement !== input) input.value = data.cep;
      var place = data.city ? escapeHtml(data.street ? data.street + ', ' : '') + '<strong>' + escapeHtml(data.city + ' - ' + data.uf) + '</strong>' : 'CEP <strong>' + escapeHtml(data.cep) + '</strong>';
      result.innerHTML =
        '<p class="bibi-cep__place">Entrega para ' + place + '</p>' +
        (S.shippingMessage ? '<p class="bibi-cep__message">' + escapeHtml(S.shippingMessage) + '</p>' : '');
      result.hidden = false;
    });
  }

  function showCepError(box, message) {
    var result = box.querySelector('[data-bibi-cep-result]');
    result.innerHTML = '<p class="bibi-cep__error">' + escapeHtml(message) + '</p>';
    result.hidden = false;
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-bibi-cep-input]')) event.target.value = maskCep(event.target.value);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-bibi-cep-form]');
    if (!form) return;
    event.preventDefault();

    var box = form.closest('[data-bibi-cep-box]');
    var input = form.querySelector('[data-bibi-cep-input]');
    var digits = input.value.replace(/\D/g, '');
    if (digits.length !== 8) { showCepError(box, 'Digite um CEP válido com 8 números.'); return; }

    var button = form.querySelector('button');
    button.disabled = true;
    var base = { cep: maskCep(digits) };

    fetch('https://viacep.com.br/ws/' + digits + '/json/')
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (json) {
        if (json && json.erro) { showCepError(box, 'CEP não encontrado. Confira os números.'); return; }
        var data = { cep: base.cep, city: json.localidade || '', uf: json.uf || '', street: json.logradouro || '' };
        saveCep(data);
        renderCep(data);
        if (box.closest('[data-bibi-cep-modal]')) setTimeout(closeCepModal, 1400);
      })
      .catch(function () {
        saveCep(base);
        renderCep(base);
      })
      .then(function () { button.disabled = false; });
  });

  var lastFocus = null;
  function openCepModal() {
    var modal = document.querySelector('[data-bibi-cep-modal]');
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('bibi-modal-open');
    var input = modal.querySelector('[data-bibi-cep-input]');
    if (input) setTimeout(function () { input.focus(); }, 30);
  }

  function closeCepModal() {
    var modal = document.querySelector('[data-bibi-cep-modal]');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('bibi-modal-open');
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-bibi-cep-open]')) { event.preventDefault(); openCepModal(); }
    else if (event.target.closest('[data-bibi-cep-close]')) closeCepModal();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCepModal();
  });

  /* ------------------------------------------------------------------ *
   * Opções de pagamento (tabela de parcelas)
   * ------------------------------------------------------------------ */
  function buildPayments(price) {
    var rows = '';
    if (S.pixEnabled && S.pixDiscount > 0) {
      rows += '<div class="bibi-payments__row bibi-payments__row--pix"><span>Pix (' + S.pixDiscount + '% de desconto)</span><strong>' +
        escapeHtml(stripTags(formatMoney(pixPrice(price)))) + '</strong></div>';
    }
    var n = installments(price) || 1;
    rows += '<p class="bibi-payments__title">Cartão de crédito</p>';
    for (var i = 1; i <= n; i++) {
      rows += '<div class="bibi-payments__row"><span>' + i + 'x de ' + escapeHtml(stripTags(formatMoney(Math.floor(price / i)))) +
        (i > 1 ? ' ' + escapeHtml(S.installmentsSuffix || '') : '') + '</span><strong>' + escapeHtml(stripTags(formatMoney(price))) + '</strong></div>';
    }
    return rows;
  }

  var openModalEl = null;
  function openModal(modal) {
    lastFocus = document.activeElement;
    modal.hidden = false;
    openModalEl = modal;
    document.documentElement.classList.add('bibi-modal-open');
  }

  function closeAnyModal() {
    if (openModalEl) {
      openModalEl.hidden = true;
      openModalEl = null;
      document.documentElement.classList.remove('bibi-modal-open');
      if (lastFocus) lastFocus.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-bibi-payments-open]');
    if (opener) {
      var box = opener.closest('[data-bibi-price-box]');
      var modal = box.parentNode.querySelector('[data-bibi-payments-modal]');
      if (!modal) return;
      modal.querySelector('[data-bibi-payments-body]').innerHTML = buildPayments(parseInt(box.getAttribute('data-price'), 10) || 0);
      openModal(modal);
      return;
    }
    if (event.target.closest('[data-bibi-modal-close]')) closeAnyModal();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAnyModal();
  });

  /* ------------------------------------------------------------------ *
   * Carrosséis horizontais (atalhos de categoria)
   * ------------------------------------------------------------------ */
  function updateArrows(scroller) {
    var track = scroller.querySelector('[data-bibi-scroller-track]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    scroller.classList.toggle('has-overflow', max > 0);
    scroller.classList.toggle('at-start', track.scrollLeft <= 2);
    scroller.classList.toggle('at-end', track.scrollLeft >= max);
  }

  function initScrollers(root) {
    (root || document).querySelectorAll('[data-bibi-scroller]').forEach(function (scroller) {
      var track = scroller.querySelector('[data-bibi-scroller-track]');
      if (!track || track.__bibi) return;
      track.__bibi = true;
      track.addEventListener('scroll', function () { updateArrows(scroller); }, { passive: true });
      updateArrows(scroller);
    });
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-bibi-scroll]');
    if (!arrow) return;
    var track = arrow.closest('[data-bibi-scroller]').querySelector('[data-bibi-scroller-track]');
    track.scrollBy({ left: track.clientWidth * 0.8 * parseInt(arrow.getAttribute('data-bibi-scroll'), 10), behavior: 'smooth' });
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-bibi-scroller]').forEach(updateArrows);
  });

  /* ------------------------------------------------------------------ *
   * Inicialização (também no editor de temas)
   * ------------------------------------------------------------------ */
  function init(root) {
    initCountdowns(root);
    initScrollers(root);
    initSticky(root);
    renderCep(readCep());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  window.BibiFashion = { formatMoney: formatMoney, pixPrice: pixPrice, installments: installments };
})();
